import { Title } from '@/components/ui/layout';
import { Input } from '@/components/ui/field';
import { Button } from '@/components/ui/button';
import { Link } from '@/components/ui/link';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/i18n/language-context';
import { useDonorCopy } from './copy';

import { browserHandoffUrl } from './browser-handoff-url';

export function BrowserHandoff(): JSX.Element {
  const { t } = useDonorCopy();
  const { locale } = useLanguage();
  const { pathname } = useLocation();
  const [message, setMessage] = useState('');
  const url = browserHandoffUrl(pathname, window.location.origin, locale);
  return (
    <aside
      className="ui-section ui-section--card ui-stack giving-browser-handoff"
      aria-label={t.browserTitle}
    >
      <Title level={2}>{t.browserTitle}</Title>
      <p>{t.browserHelp}</p>
      <p className="giving-note">{t.browserLocal}</p>
      <Input
        aria-label={t.copyLink}
        readOnly
        value={url}
        onFocus={(event) => event.target.select()}
      />
      <div className="giving-actions">
        <Button
          variant="secondary"
          type="button"

          onClick={() => {
            if (!navigator.clipboard) {
              setMessage(t.copyManually);
              return;
            }
            void navigator.clipboard.writeText(url).then(
              () => setMessage(t.copiedLink),
              () => setMessage(t.copyManually),
            );
          }}
        >
          {t.copyLink}
        </Button>
        <Link className="giving-text-link" href={url} target="_blank" rel="noopener noreferrer">
          {t.openBrowser}
        </Link>
      </div>
      {message && <p role="status">{message}</p>}
    </aside>
  );
}
